module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title":"리뷰 운영방식","review_permission":"작성 권한이 있는 자의 범위","review_publication_period":"게시기간","rating_criteria_and_impact":"등급평가 기준 및 등급에 따른 효과","review_deletion_criteria_and_appeal_procedures":"삭제 기준 및 삭제 시 이의제기 절차"}}')
  delete Component.options._Ctor
}
